import React from "react";
import useWithStore from "@/Hooks/useWithStore";
import useScrollDirection from "@/Hooks/useScrollDirection";
import {useAllStore} from "@/Stores/useAllStore";
import Svg from "@/Components/Svg";
import FilterLayout from "@/Layouts/FilterLayout";
import Sort from "@/Pages/Site/Catalog/Sort";
import SelectedFilters from "@/Pages/Site/Catalog/SelectedFilters";

const Filters = (props) => {
    const {stores = {}, filters = [], insertColors = [], isDesktop = false} = props;
    const {modalStore = {}} = stores;

    const headerHeight = useAllStore((state) => state.headerHeight);
    const scrollDirection = useScrollDirection();

    return (
        <div className={`filterContainer`}
             style={{top: scrollDirection === "down" ? '0px' : headerHeight + 'px'}}>
            <div className={`filters`}>
                <div className={`filters--all`}>
                    {/*<div className={`dropdown-filter active`} onClick={() => modalStore.openFiltersDrawer()}>*/}
                    {/*    <div className={`dropdown-filter__name active`}>*/}
                    <div className={`dropdown-filter`} onClick={() => modalStore.openFiltersDrawer()}>
                        <div className={`dropdown-filter__name`}>
                            <Svg id={`allFiltersIcon`} className={`svg__allFiltersIcon`} />
                            <p>Все фильтры</p>
                        </div>
                    </div>
                </div>
                <div className={`filters--list`}>
                    {filters.map((filter, index) => {
                        const visible = filter.visible && (isDesktop ? filter.visibleDesktop : filter.visibleMobile);
                        const visibleOptionsCount = isDesktop ? filter.visibleOptionsCountDesktop : filter.visibleOptionsCountMobile
                        return <FilterLayout
                            key={index}
                            filter={{
                                ...filter,
                                visible: visible,
                                visibleOptionsCount: visibleOptionsCount
                            }}
                            content={isDesktop}
                            insertColors={insertColors}
                            isDesktop={isDesktop}
                        />
                    })}
                </div>
                <Sort {...props} />
                <SelectedFilters className={`filters--chips`} {...props} />
            </div>
        </div>
    );
};

export default useWithStore(Filters);
